<template>
  <div>
    <a-menu
      v-model="loggedInUserMenu"
      rounded
      offset-y
      :close-on-content-click="false"
      dense
      nudge-bottom="2"
      :disabled="isSessionexpired"
    >
      <template v-slot:activator="{ on, attrs }">
        <a-btn class="mr-5" text v-bind="attrs" v-on="on">
          <v-avatar class="mr-2" size="32">
            <v-img
              v-if="$auth.user.profile_photo_thumbnail"
              :src="$auth.user.profile_photo_thumbnail"
            ></v-img>
            <v-img v-else :src="$auth.user.picture"></v-img>
          </v-avatar>
          <span
            style="
              max-width: 200px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          >
            {{ getName($auth.user) }}
          </span>
        </a-btn>
      </template>
      <logged-in-user
        v-if="isTenantLoaded"
        :userInfo="userInfo"
        @changePassword="onChangePassword"
      ></logged-in-user>
    </a-menu>
    <change-password
      v-if="changePasswordDialog"
      v-model="changePasswordDialog"
    ></change-password>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AMenu from "../../wrapper-component/AMenu.vue";
import ABtn from "../../wrapper-component/ABtn.vue";
import ChangePassword from "../ChangePassword.vue";
import LoggedInUser from "../LoggedInUser.vue";
export default {
  components: { ABtn, LoggedInUser, ChangePassword, AMenu },
  name: "UserMenu",
  props: {
    userInfo: Object,
  },
  data() {
    return {
      changePasswordDialog: false,
      loggedInUserMenu: false,
    };
  },
  methods: {
    onChangePassword,
    getName(userDetails) {
      const { tenantUserName, name } = userDetails;
      const userName = tenantUserName || name;

      if (userName && userName.trim() !== "") {
        if (userName.length > 20) {
          const fullName = userName.split(" ");
          return fullName[0];
        } else {
          return userName;
        }
      }
      return "";
    },
  },
  computed: {
    ...gettersMap(),
    isTenantLoaded() {
      return Boolean(sessionStorage.getItem("tenantId"));
    },
    isSessionexpired() {
      return this.$route.path.startsWith("/sessionexpired");
    },
  },
};
function onChangePassword() {
  this.loggedInUserMenu = false;
  this.changePasswordDialog = true;
}
function gettersMap() {
  return mapGetters({
    meetingTypes: "tenant/agendaMeetingTypes",
  });
}
</script>

<style>
</style>